import React, { Component } from 'react'
import { Button, Drawer, Form, Select } from 'antd';
import Swal from "sweetalert2";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {withTourGuide} from "../../guideComponent/withTourGuide";

class UserLevelAdd extends Component {
    constructor() {
        super();
        this.state = {
            level_name: '',
            level_page_limited: null,
            level_divisi_limited: null,
            level_action_limited: null,
            loading: false
        }
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        showGuide(target, config);
    };

    levelHandler = () => {
        if (this.state.level_page_limited == null) {
            this.setState({
                level_page_limited: ''
            })
        } else {
            this.setState({
                level_page_limited: null
            })
        }
    }

    actionHandler = () => {
        if (this.state.level_action_limited == null) {
            this.setState({
                level_action_limited: ''
            })
        } else {
            this.setState({
                level_action_limited: null
            })
        }
    }

    divisiHandler = () => {
        if (this.state.level_divisi_limited == null) {
            this.setState({
                level_divisi_limited: ''
            })
        } else {
            this.setState({
                level_divisi_limited: null
            })
        }
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        })
        let form = {
            level_name: this.state.level_name,
            level_page_limited: this.state.level_page_limited,
            level_divisi_limited: this.state.level_divisi_limited,
            level_action_limited: this.state.level_action_limited,
        }

        this.props.request("userlevel/add", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({ level_name: '', level_page_limited: '',level_action_limited: '' })
                    this.props.changeState({
                        level_name: '',
                        level_page_limited: '',
                        level_divisi_limited: '',
                        level_action_limited: '',
                        add_visible: false,
                        data: [],
                        isLoading: true,
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                } else {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    loading: false
                })
            });
    }

    render() {
        const { Option } = Select;
        return (

                <Modal size="lg" zIndex={999} isOpen={this.props.add_visible} toggle={() => {
                    this.props.changeState({ add_visible: false });
                }}>
                    <ModalHeader toggle={() => {
                        this.setState({ level_name: '' });
                        this.props.changeState({ add_visible: false });
                    }}>Tambah User Level</ModalHeader>
                    <ModalBody>
                        <div className="px-2">
                            <Form layout="vertical" hideRequiredMark>
                                <div
                                    className="form-group"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideLevelNameAdd",
                                            title: "Nama User Level",
                                            content: "Masukkan nama level user baru. Nama ini digunakan untuk membedakan role dan hak akses di sistem."
                                        });
                                    }}
                                >
                                    <label>Nama User Level</label>
                                    <input
                                        name="level_name"
                                        className="form-control col-xl-12 col-md-12"
                                        placeholder="Nama User Level..."
                                        type="text"
                                        required=""
                                        value={this.state.level_name}
                                        onChange={(event) => {
                                            const target = event.target;
                                            const value = target.value;
                                            const name = target.name;
                                            this.setState({
                                                [name]: value
                                            });
                                        }}
                                    />
                                </div>

                                <div
                                    className="form-group"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesHalamanAdd",
                                            title: "Akses Halaman Level User",
                                            content: "Atur halaman yang dapat diakses oleh level user baru. Bisa seluruh halaman atau hanya halaman tertentu."
                                        });
                                    }}
                                >
                                    <label>Akses Halaman Level User</label><br />
                                    <label
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guideAksesHalamanSemuaAdd",
                                                title: "Seluruh Akses Halaman",
                                                content: "Aktifkan opsi ini jika level user baru boleh mengakses semua halaman tanpa pembatasan."
                                            });
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={this.state.level_page_limited === null}
                                            onChange={() => this.levelHandler()}
                                        />
                                        &nbsp;Seluruh Akses Halaman
                                    </label>

                                    {this.state.level_page_limited !== null &&
                                        <div
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "guidePilihAksesHalamanAdd",
                                                    title: "Pilih Akses Halaman",
                                                    content: "Pilih satu atau beberapa halaman yang boleh diakses oleh level user baru ini."
                                                });
                                            }}
                                        >
                                            <Select
                                                name="level_page_limited"
                                                style={{ width: '100%' }}
                                                mode={"multiple"}
                                                placeholder="Pilih Akses Halaman"
                                                onChange={(event) => {
                                                    this.setState({
                                                        level_page_limited: event
                                                    })
                                                }}
                                                options={this.props.levelOption}
                                            >
                                            </Select>
                                        </div>
                                    }
                                </div>

                                <div
                                    className="form-group"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesDivisiAdd",
                                            title: "Akses Divisi Karyawan",
                                            content: "Atur divisi karyawan yang dapat diakses oleh level user baru. Bisa semua divisi atau hanya divisi tertentu."
                                        });
                                    }}
                                >
                                    <label>Akses Divisi Karyawan</label><br />
                                    <label
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guideAksesDivisiSemuaAdd",
                                                title: "Seluruh Akses Divisi",
                                                content: "Aktifkan opsi ini jika level user baru boleh mengakses seluruh divisi karyawan."
                                            });
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={this.state.level_divisi_limited === null}
                                            onChange={() => this.divisiHandler()}
                                        />
                                        &nbsp;Seluruh Akses Divisi
                                    </label>

                                    {this.state.level_divisi_limited !== null &&
                                        <div
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "guidePilihAksesDivisiAdd",
                                                    title: "Pilih Akses Divisi",
                                                    content: "Pilih satu atau beberapa divisi yang boleh diakses oleh level user baru ini."
                                                });
                                            }}
                                        >
                                            <Select
                                                name="level_divisi_limited"
                                                style={{ width: '100%' }}
                                                mode={"multiple"}
                                                placeholder="Pilih Akses Divisi"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                onChange={(event) => {
                                                    this.setState({
                                                        level_divisi_limited: event
                                                    })
                                                }}
                                            >
                                                {this.props.divisi.map((item, index) => {
                                                    return (
                                                        <Option key={item.divisi_id || index} value={item.divisi_id}>
                                                            {item.divisi_name}
                                                        </Option>
                                                    )
                                                })}
                                            </Select>
                                        </div>
                                    }
                                </div>

                                <div
                                    className="form-group"
                                    onPointerEnter={(e) => {
                                        this.triggerGuideOnce(e, {
                                            key: "guideAksesAksiAdd",
                                            title: "Akses Aksi Level User",
                                            content: "Atur jenis aksi yang boleh dilakukan oleh level user baru, seperti tambah, lihat, ubah, atau hapus data."
                                        });
                                    }}
                                >
                                    <label>Akses Aksi Level User</label><br />
                                    <label
                                        onPointerEnter={(e) => {
                                            this.triggerGuideOnce(e, {
                                                key: "guideAksesAksiSemuaAdd",
                                                title: "Seluruh Akses Aksi",
                                                content: "Aktifkan opsi ini jika level user baru boleh menggunakan seluruh aksi yang tersedia di sistem."
                                            });
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={this.state.level_action_limited === null}
                                            onChange={() => this.actionHandler()}
                                        />
                                        &nbsp;Seluruh Akses Aksi
                                    </label>

                                    {this.state.level_action_limited !== null &&
                                        <div
                                            onPointerEnter={(e) => {
                                                this.triggerGuideOnce(e, {
                                                    key: "guidePilihAksesAksiAdd",
                                                    title: "Pilih Akses Aksi",
                                                    content: "Pilih aksi yang diizinkan. Jika memilih Ubah atau Hapus, sistem otomatis menambahkan akses Lihat."
                                                });
                                            }}
                                        >
                                            <Select
                                                name="level_action_limited"
                                                style={{ width: '100%' }}
                                                mode={"multiple"}
                                                placeholder="Pilih Akses Aksi"
                                                value={this.state.level_action_limited != "" ? this.state.level_action_limited : []}
                                                onChange={(selectedValues) => {
                                                    let updatedValues = selectedValues;
                                                    if (selectedValues.includes('U') || selectedValues.includes('D')) {
                                                        updatedValues = Array.from(new Set([...selectedValues, 'R']));
                                                    }

                                                    this.setState({
                                                        level_action_limited: updatedValues
                                                    });
                                                }}
                                                options={[
                                                    { label: 'Create (Tambah Data)', value: 'C' },
                                                    { label: 'Read (Lihat Data)', value: 'R' },
                                                    { label: 'Update (Ubah Data)', value: 'U' },
                                                    { label: 'Delete (Hapus Data)', value: 'D' },
                                                ]}
                                            >
                                            </Select>
                                        </div>
                                    }
                                </div>
                            </Form>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button
                                onClick={() => {
                                    this.setState({ level_name: '' })
                                    this.props.changeState({ add_visible: false })
                                }}
                                style={{marginRight: 8}}>
                                Batal
                            </Button>
                            <Button onClick={this.handleSubmit} disabled={this.state.loading} type="primary">
                                {this.state.loading ?
                                    <><i className={"fa fa-refresh fa-spin"}></i> Loading</>
                                    :
                                    "Simpan"
                                }
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>

        )
    }
}

export default withTourGuide(UserLevelAdd)